import React from 'react'
import './spinner.css';

export const Spinner = () => {
  return (<div className='w-full h-full flex justify-center items-center' >
      <div className='spinner mt-[15%]'></div>
    </div>
  )
}
